export const flashSuccess = () => {};
export const flashNotice = () => {};
export const flashLoading = () => {};
export const flashError = () => {};

export const flashDismiss = () => {};
export const flashReset = () => {};
